
import { defineComponent } from 'vue'
import { BillingInterval } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingCurrentPlanCard',
  props: {
    name: {
      type: String,
      default: 'Free'
    },
    sku: {
      type: String,
      default: 'target'
    },
    monthlyAmount: {
      type: Number,
      default: 0
    },
    annualAmount: {
      type: Number,
      default: 0
    },
    totalSeats: {
      type: Number,
      default: 0
    },
    billingMode: {
      type: String,
      default: 'monthly',
      validator: (value: string | BillingInterval | null) =>
        ['monthly', 'annual', BillingInterval.Annual, BillingInterval.Monthly, null].includes(value)
    },
    upcomingPaymentDate: {
      type: String,
      default: null,
      validator: (value: string | null) => {
        if (value === null) return true
        const date = new Date(value)
        return !isNaN(date.getTime())
      }
    },
    upcomingPaymentAmount: {
      type: Number,
      default: null
    },
    outstandingCredits: {
      type: Number,
      default: null
    },
    freeText: {
      type: String,
      default: '3 targets included, limited analysis and remediation'
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    allowBillingChange: {
      type: Boolean,
      default: true
    },
    seatUpdateLoading: {
      type: Boolean,
      default: false
    },
    intervalUpdateLoading: {
      type: Boolean,
      default: false
    },
    manualMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    skuLabel() {
      if (this.sku.toLowerCase() === 'user') {
        return 'Seats'
      }
      return 'Targets'
    },
    BillingInterval() {
      return BillingInterval
    },
    isMonthly() {
      return this.billingMode === 'monthly' || this.billingMode === BillingInterval.Monthly
    }
  },
  methods: {
    formatDate,
    parseISODate
  }
})
